import axios from '@/utils/request'
// 获取菜单列表
export const getMenu = (params)=>{
 return axios.request({
    url: 'v1/role/menu',
    method: 'get',
    params
  })
};
// 添加菜单
export const createMenu = (data)=>{
  return axios.request({
     url: 'system/menu',
     method: 'post',
     data
   })
 };
// 修改菜单
export const editMenu = (id,data)=>{
  return axios.request({
     url: 'system/menu/'+id,
     method: 'put',
     data
   })
 };
// 批量删除菜单
export const delMenu = (ids)=>{
  return axios.request({
     url: 'system/menu/mutiDel',
     method: 'get',
     params:{ids}
   })
 };


// 用户列表

export const getAdmin = (params)=>{
  return axios.request({
     url: 'v1/user/index',
     method: 'get',
     params
   })
 };

// 用户详情
export const adminDetail = (id)=>{
  return axios.request({
     url: 'v1/user/detail?id='+id,
     method: 'get',
   })
 };
//  新增用户
export const createAdmin = (data)=>{
  return axios.request({
     url: 'v1/user/add',
     method: 'post',
     data
   })
 };
//  获取绑定二维码
export const getAdminCode = ()=>{
  return axios.request({
     url: 'v1/user/code',
     method: 'get'
   })
 };
 
// 修改用户
export const editAdmin = (data)=>{
  return axios.request({
     url: 'v1/user/edit',
     method: 'post',
     data
   })
 };
 // 删除用户
export const delAdmin = (id)=>{
  return axios.request({
     url: '/v1/user/del',
     method: 'post',
     data:{id}
   })
 };
 
 // 修改用户状态
export const statusAdmin = (status,id)=>{
  return axios.request({
     url: '/v1/user/status',
     method: 'post',
     data:{
      id,
      status
     }
   })
 };
//  角色列表
export const getRole = (params)=>{
  return axios.request({
     url: 'v1/role/index',
     method: 'get',
     params
   })
 };
//  新增角色
export const createRole = (data)=>{
  return axios.request({
     url: 'v1/role/add',
     method: 'post',
     data
   })
 };
//  角色详情
export const roleDetail = (id,params)=>{
  return axios.request({
     url: 'v1/role/detail',
     method: 'get',
     params:{
      role_id:id,
      ...params
     }
   })
 };

// 删除角色
export const delRole = (id)=>{
  return axios.request({
     url: 'v1/role/'+id,
     method: 'DELETE',
   })
 };
 // 修改角色
export const editRole = (data)=>{
  return axios.request({
     url: 'v1/role/edit',
     method: 'post',
     data
   })
 };

  
 // 修改用户状态
export const statusRole = (status,id)=>{
  return axios.request({
     url: 'system/role/'+id+'/'+status,
     method: 'put',
   })
 };

  // 操作日志
  export const getLogs = (params)=>{
    return axios.request({
       url: 'v1/log/index',
       method: 'get',
       params
     })
   };

 // 支付方式管理列表
 export const getPayList = (params)=>{
  return axios.request({
     url: 'v1/pay/index',
     method: 'get',
     params
   })
 };
 // 支付方式
 export const getPayTypeList = (params)=>{
  return axios.request({
     url: 'v1/pay/list',
     method: 'get',
     params
   })
 };
  // 支付方式状态修改
  export const getPayStatus = (data)=>{
    return axios.request({
       url: 'v1/pay/status',
       method: 'post',
       data
     })
   };
  // 支付方式删除
  export const getPayDel = (data)=>{
    return axios.request({
       url: 'v1/pay/del',
       method: 'post',
       data
     })
   };
 
// 获取支付配置
export const getPayConfig = (params)=>{
  return axios.request({
     url: 'v1/pay/getConfig',
     method: 'get',
     params
   })
 };
 // 编辑配置
export const editPayConfig = (data)=>{
  return axios.request({
     url: 'v1/pay/editConfig',
     method: 'POST',
     data
   })
 };
 // 添加支付方式
export const addPay = (data)=>{
  return axios.request({
     url: 'v1/pay/add',
     method: 'POST',
     data
   })
 };

 /**
  * 商户信息管理
  */

//品牌商信息
export const getInfoDetail = (params)=>{
  return axios.request({
    url: 'v1/brand/infoDetail',
    method: 'get',
    params
  })
};
//品牌商修改（基础信息）
export const setInfoUpdate = (data)=>{
  return axios.request({
    url: 'v1/brand/infoUpdate',
    method: 'PATCH',
    data
  })
};
//品牌商修改（账号信息）
export const setAccountInfoUpdate = (data)=>{
  return axios.request({
    url: 'v1/brand/accountInfoUpdate',
    method: 'PATCH',
    data
  })
};
//认证信息
export const getCertList = (params)=>{
  return axios.request({
    url: 'v1/brand/certLists',
    method: 'get',
    params
  })
};
//企业营业执照修改
export const setLicenseUpdate = (data)=>{
  return axios.request({
    url: 'v1/brand/licenseUpdate',
    method: 'PATCH',
    data
  })
};
//中国商标权证书修改
export const setTrademarkUpdate = (data)=>{
  return axios.request({
    url: 'v1/brand/trademarkUpdate',
    method: 'PATCH',
    data
  })
};
//行业列表
export const getIndustry = (params)=>{
  return axios.request({
    url: 'v1/brand/industry',
    method: 'get',
    params
  })
};

//商户信息-订单列表
export const getBusinessOrder = (params)=>{
  return axios.request({
    url: 'v1/business/order',
    method: 'get',
    params
  })
};
export const getBusinessOrderMore = (params)=>{
  return axios.request({
    url: 'v1/business/detail',
    method: 'get',
    params
  })
};

// 修改密码

export const editPassword = (data)=>{
  return axios.request({
    url: 'v1/brand/changePassword',
    method: 'post',
    data
  })
};

// 设置微信绑定用户
export const userInit = (data)=>{
  return axios.request({
    url: 'v1/user/init',
    method: 'post',
    data
  })
};


// 品牌商-账号余额查询
export const bill_index = (data)=>{
  return axios.request({
    url: 'v1/business/bill_index',
    method: 'get',
    data
  })
};
// 品牌商-账号余额信息
export const balance_info = (data)=>{
  return axios.request({
    url: 'v1/business/balance_info',
    method: 'get',
    data
  })
};
// 品牌商-账号余额-导出
export const exporTbalance = (params)=>{
  return axios.request({
    url: 'v1/business/bill_export',
    method: 'get',
    params
  })
};


// 设置是否允许PDA登录
export const set_pda_login = (data)=>{
  return axios.request({
    url: 'v1/user/set_pda_login',
    method: 'post',
    data
  })
};
